import { VideoCardSide as Component } from './VideoCardSide';

export { VideoCardSide } from './VideoCardSide';
export { useVideoCardSide } from './useVideoCardSide';
export * from './types';
export * from './utils';

// 既存のimport文との互換性のためにデフォルトエクスポートも提供
export default Component; 